// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ec4ad761","703":"1fa7dda9"}[chunkId] + ".chunk.js";
};